<template>
  <div
    class="o-mobile-footer flex flex-col justify-center items-center lg:hidden"
  >
    <div class="text-white text-xs mb-4 tracking-wider">
      <ul class="flex items-center justify-around">
        <li class="mr-4">
          <FooterButton
            alt="Sobre a Plataforma"
            icon="images/login/info.svg"
            @click="() => setAboutModalOpen(true)"
          >
            Sobre a Plataforma
          </FooterButton>
        </li>
        <li class="mr-4">
          <FooterButton
            alt="Notas Gerais"
            icon="images/login/info.svg"
            @click="() => setNotesModalOpen(true)"
          >
            Notas Gerais
          </FooterButton>
        </li>
        <li>
          <FooterButton
            alt="Fale Conosco"
            icon="images/login/support.svg"
            @click="() => setContactModalOpen(true)"
          >
            Fale Conosco
          </FooterButton>
        </li>
      </ul>
    </div>
    <div class="w-full text-white text-xs">
      <ul class="items-center justify-center flex w-full mb-4">
        <li class="mr-2">
          <FooterCompanyLogo />
        </li>
        <li class="ml-4">
          <FooterLogo />
        </li>
        <li class="ml-6">
          <p>
            3D
            <span
              class="before:content-['|'] before:inline-block before:w-auto before:h-full hover:underline"
            >
              <FooterLink
                href="https://visualles.com"
                title="Acesse o site da Visualles"
              >
                Visualles
              </FooterLink>
            </span>
          </p>
        </li>
      </ul>
      <ul
        class="items-center justify-center flex text-white text-xs tracking-wider w-full"
      >
        <li>
          <p>
            Todos os direitos reservados
            <span
              class="before:content-['|'] before:inline-block before:w-auto before:h-full"
            >
              by
              <FooterLink
                href="http://www.altamidia.com.br"
                title="Acesse o site da Altamidia"
              >
                Altamidia
              </FooterLink>
            </span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FooterCompanyLogo from "@/components/atoms/FooterCompanyLogo.vue";
import FooterLogo from "@/components/atoms/FooterLogo.vue";
import FooterButton from "@/components/molecules/FooterButton.vue";
import FooterLink from "@/components/atoms/FooterLink.vue";
import useFooter from "@/composables/useFooter";

export default {
  name: "MobileFooter",
  components: { FooterButton, FooterCompanyLogo, FooterLink, FooterLogo },
  setup() {
    const { setAboutModalOpen, setContactModalOpen, setNotesModalOpen } =
      useFooter();

    return {
      setAboutModalOpen,
      setContactModalOpen,
      setNotesModalOpen,
    };
  },
};
</script>
